import request from '@/utils/request'
const BASE_URL = '/Timetable'


export default {
  list(data) {
    if (!data) {
      data = { PageIndex: 1, PageSize: 100 }
    }
    return request({
      url: BASE_URL + '/List',
      method: 'post',
      data
    })
  },
  info(id) {
    return request({
      url: BASE_URL + '/Info',
      method: 'get',
      params: { id }
    })
  },
  save(data) {
    return request({
      url: BASE_URL + '/Save',
      method: 'post',
      data
    })
  },
  saveV2(data) {
    return request({
      url: BASE_URL + '/SaveV2',
      method: 'post',
      data
    })
  },
  delete(data) {
    return request({
      url: BASE_URL + '/Delete',
      method: 'post',
      data
    })
  },
  import: "/api" + BASE_URL + "/Import",
  importV2: "/api" + BASE_URL + "/ImportV2",
  getTimetable(classId, weekStartDate, weekEndDate) {
    return request({
      url: BASE_URL + '/GetTimetableSections',
      method: 'get',
      params: { classId, weekStartDate, weekEndDate }
    })
  },
  getTimetableV2(classId, weekStartDate, weekEndDate) {
    return request({
      url: BASE_URL + '/GetTimetableSectionsV2',
      method: 'get',
      params: { classId, weekStartDate, weekEndDate }
    })
  },
  getTeacher(termId, classId, subject = "") {
    return request({
      url: BASE_URL + '/GetTeachersTeachings',
      method: 'get',
      params: { termId, classId, subject }
    })
  },
  export(data) {
    return request({
      url: BASE_URL + '/Export',
      method: 'post',
      responseType: 'blob',
      data
    }).then(res => {
      var file = res.data;
      var disposition = res.headers['content-disposition'];
      // console.log('disposition', disposition);

      var fileName = "导出";
      if (disposition.lastIndexOf("filename*=UTF-8''") != -1) {
        var text = disposition.substr(disposition.lastIndexOf("filename*=UTF-8''") + ("filename*=UTF-8''").length)
        fileName = decodeURI(text);
      }

      if (navigator.msSaveBlob) {
        // IE10+下载
        navigator.msSaveBlob(file, fileName);
      } else {
        const elink = document.createElement("a");
        elink.download = fileName;
        elink.style.display = "none";
        elink.target = "_blank";
        elink.href = URL.createObjectURL(file);
        document.body.appendChild(elink);
        elink.click();
        URL.revokeObjectURL(elink.href); // 释放URL 对象
        document.body.removeChild(elink);
      }
      return Promise.resolve();
    });
  }
}